import hrApi from '@/api/v1/hr';
import assign from 'lodash/assign';

export default {
  namespaced: true,

  state: {
    issues: [],
    totals: 0,
    pagination: {
      page: 1,
      itemsPerPage: 20,
      mustSort: false,
      multiSort: true,
      sortBy: [],
      sortDesc: [],
    },
    isDataLoading: false,
  },

  mutations: {
    CHANGE_ISSUES(state, { issues }) {
      state.issues = issues;
    },

    CHANGE_PAGINATION(state, pagination) {
      state.pagination = assign(state.pagination, pagination);
    },

    CHANGE_TOTALS_NUMBER(state, totals) {
      state.totals = totals;
    },

    CHANGE_LOADING_STATUS(state, { status }) {
      state.isDataLoading = status;
    },
  },

  actions: {
    fetchIssues({ state, commit }) {
      commit('CHANGE_LOADING_STATUS', { status: true });

      return new Promise((resolve, reject) => {
        hrApi.issues
          .index(state.pagination)
          .then((resp) => {
            commit('CHANGE_TOTALS_NUMBER', resp.data.pagination.itemsLength);
            commit('CHANGE_PAGINATION', { pagination: resp.data.pagination });
            commit('CHANGE_ISSUES', { issues: resp.data.collection });
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', { status: false });
          });
      });
    },

    setPagination({ commit }, pagination) {
      commit('CHANGE_PAGINATION', pagination);
    },
  },
};
